import { Button, HStack } from '@chakra-ui/react';
import React from 'react';
import ProfileDropdownMenu from '../../ProfileDropdownMenu';
import sharedRoutes from '@/constants/routes/shared';
import { primary, text } from '@/theme/colors/palettes';
import svgIcons from '@/assets/svg/icons';
import SvgIcon from '@/components/atoms/SvgIcon';
import authMessages from '@/messages/auth';
import { Link, useRouterState } from '@tanstack/react-router';
import NotificationsBell from '../../NotificationsBell';
import { useAuthContext } from '@/context/auth/useAuthContext';
import { orgAdminRoutes } from '@/constants/routes/app';

interface Props {
  isTransparent: boolean;
}

const DefaultHeader = ({ isTransparent }: Props) => {
  const { isAdmin, isPeerSupport } = useAuthContext();

  const { pathname } = useRouterState({ select: (state) => state.resolvedLocation });

  const isContactSupport = pathname === sharedRoutes.contactSupport;
  const contactSupportColor = isContactSupport ? primary['500'] : isTransparent ? 'white' : text.mediumGray;
  const isOnboarding = pathname.includes('onboarding');

  const isOrganizationDashboard = pathname.includes('organization/dashboard');
  const isOrganizationRoster = pathname.includes('organization/roster');

  const organizationDashboardColor = isOrganizationDashboard
    ? primary['500']
    : isTransparent
      ? 'white'
      : text.mediumGray;
  const organizationRosterColor = isOrganizationRoster ? primary['500'] : isTransparent ? 'white' : text.mediumGray;

  return (
    <HStack gap={'10px'}>
      {!isAdmin && !isPeerSupport && (
        <Button
          as={Link}
          variant={'headerLinkButton'}
          backgroundColor={'transparent'}
          boxShadow={'none'}
          color={contactSupportColor}
          to={sharedRoutes.contactSupport}
          paddingX={'10px'}
          leftIcon={
            <HStack width={'20px'} alignItems={'center'}>
              <SvgIcon iconPath={svgIcons.email} size={19} color={contactSupportColor} />
            </HStack>
          }
        >
          {authMessages.contactSupport}
        </Button>
      )}

      <HStack>
        {(isAdmin || isPeerSupport) && (
          <Button
            as={Link}
            variant={'headerLinkButton'}
            backgroundColor={'transparent'}
            boxShadow={'none'}
            color={organizationDashboardColor}
            to={orgAdminRoutes.organizationDashboard}
            paddingX={'10px'}
            leftIcon={
              <HStack width={'20px'} alignItems={'center'}>
                <SvgIcon iconPath={svgIcons.dashboard} size={19} color={organizationDashboardColor} />
              </HStack>
            }
          >
            Organization Dashboard
          </Button>
        )}
        {isAdmin && (
          <Button
            as={Link}
            variant={'headerLinkButton'}
            backgroundColor={'transparent'}
            boxShadow={'none'}
            color={organizationRosterColor}
            to={orgAdminRoutes.organizationRoster}
            paddingX={'10px'}
            leftIcon={
              <HStack width={'20px'} alignItems={'center'}>
                <SvgIcon iconPath={svgIcons.users} size={19} color={organizationRosterColor} />
              </HStack>
            }
          >
            Organization Roster
          </Button>
        )}
      </HStack>

      {!isOnboarding && <NotificationsBell />}

      <ProfileDropdownMenu isHeaderTransparent={isTransparent} />
    </HStack>
  );
};

export default DefaultHeader;
